import axios, { AxiosResponse } from 'axios';


export class BannerService {
  get = async (): Promise<AxiosResponse<string>> => axios.get('/event/banner');
}
